/* class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resultsContainer = this.querySelector('[data-predictive-search-results]');

    this.input.addEventListener('input', this.onInput.bind(this));
    this.input.addEventListener('keydown', this.onKeydown.bind(this));
  }

  onInput() {
    const q = this.input.value.trim();

    if (q.length < 2) {
      this.resultsContainer.innerHTML = "";
      this.dispatchEvent(new CustomEvent("results-cleared"));
      return;
    }

    const url =
      `/search/suggest?q=${encodeURIComponent(q)}` +
      `&resources[type]=product&section_id=predictive-search`;

    fetch(url)
      .then(res => res.text())
      .then(html => {
        this.resultsContainer.innerHTML = html;
        this.dispatchEvent(new CustomEvent("results-updated"));
      })
      .catch(err => console.error("Predictive search error:", err));
  }

  onKeydown(e) {
    if (e.key === "Escape") {
      this.resultsContainer.innerHTML = "";
    }
  }

  renderResults(html) {
    this.resultsContainer.innerHTML = html;

    // Tell Alpine that results are ready
    window.dispatchEvent(new CustomEvent('results-updated'));
  }

  clearResults() {
    this.resultsContainer.innerHTML = '';

    // Tell Alpine that results were cleared
    window.dispatchEvent(new CustomEvent('results-cleared'));
  }
}

customElements.define("predictive-search", PredictiveSearch); */

// assets/predictive-search.js
(() => {
  const DEBOUNCE_MS = 180;

  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      try {
        console.log('[predictive-search] construct');
        this.input = this.querySelector('input[type="search"]');
        this.resultsContainer = this.querySelector('[data-predictive-search-results]');

        if (!this.input || !this.resultsContainer) {
          console.warn('[predictive-search] missing input or results container. Aborting initialization.');
          return;
        }

        // debounce timer
        this._debounceTimer = null;

        // bind handlers
        this._onInputBound = this._onInputDebounced.bind(this);
        this._onKeydownBound = this._onKeydown.bind(this);
        this._onResultsClickBound = this._onResultsClick.bind(this);

        this.input.addEventListener('input', this._onInputBound);
        this.input.addEventListener('keydown', this._onKeydownBound);
        this.resultsContainer.addEventListener('click', this._onResultsClickBound);

        console.log('[predictive-search] initialized', { input: this.input, resultsContainer: this.resultsContainer });
      } catch (err) {
        console.error('[predictive-search] constructor error', err);
      }
    }

    /* Debounced input handler */
    _onInputDebounced() {
      clearTimeout(this._debounceTimer);
      this._debounceTimer = setTimeout(() => this._onInput(), DEBOUNCE_MS);
    }

    /* Key handling */
    _onKeydown(e) {
      if (e.key === 'Escape') {
        this._clearResults();
        // also blur input so escape feels natural
        try { this.input.blur(); } catch (err) {}
      }
    }

    /* When user clicks a product link inside results */
    _onResultsClick(e) {
      const a = e.target.closest && e.target.closest('a[href]');
      if (a) {
        // dispatch a cleared event so Alpine can close dropdown
        window.dispatchEvent(new CustomEvent('results-cleared', { detail: { reason: 'click-result' } }));
        // allow navigation to proceed normally
      }
    }

    /* Perform fetch and inject */
    _onInput() {
      const q = (this.input.value || '').trim();
      if (q.length < 2) {
        this._clearResults();
        return;
      }

      // const locale = window.Shopify.locale || 'en';
      // const url = `/${locale}/search/suggest?q=${encodeURIComponent(q)}&resources[type]=product&section_id=predictive-search`;
      const url = `${window.routes.search_url}/suggest?q=${encodeURIComponent(q)}&resources[type]=product&section_id=predictive-search`;
      console.log('[predictive-search] fetch', url);

      fetch(url, { credentials: 'same-origin' })
        .then((r) => {
          if (!r.ok) throw new Error('Network response not ok: ' + r.status);
          return r.text();
        })
        .then((html) => {
          // inject HTML
          this.resultsContainer.innerHTML = html || '';
          console.log('[predictive-search] injected html, length:', (html || '').length);

          // dispatch updated event globally so Alpine listeners on window pick it up
          window.dispatchEvent(new CustomEvent('results-updated', { detail: { query: q } }));

          // if returned HTML is empty, also fire cleared
          if (!html || html.trim().length === 0) {
            window.dispatchEvent(new CustomEvent('results-cleared', { detail: { reason: 'empty-response' } }));
          }
        })
        .catch((err) => {
          console.error('[predictive-search] fetch error', err);
          // on error, clear results and dispatch cleared
          this._clearResults();
        });
    }

    /* Clear results and notify */
    _clearResults() {
      try {
        if (this.resultsContainer) this.resultsContainer.innerHTML = '';
      } catch (err) { /* ignore */ }
      window.dispatchEvent(new CustomEvent('results-cleared', { detail: { reason: 'cleared' } }));
      console.log('[predictive-search] cleared results');
    }

    /* Lifecycle: remove listeners if element removed */
    disconnectedCallback() {
      try {
        this.input && this.input.removeEventListener('input', this._onInputBound);
        this.input && this.input.removeEventListener('keydown', this._onKeydownBound);
        this.resultsContainer && this.resultsContainer.removeEventListener('click', this._onResultsClickBound);
        console.log('[predictive-search] disconnected');
      } catch (err) {
        console.warn('[predictive-search] disconnect error', err);
      }
    }
  }

  if (!customElements.get('predictive-search')) {
    customElements.define('predictive-search', PredictiveSearch);
    console.log('[predictive-search] custom element defined');
  } else {
    console.log('[predictive-search] custom element already defined');
  }
})();

